import React from 'react';
import { TagIcon, LightbulbIcon, PhoneIcon, ArrowDownIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { CTABand } from '../components/CTABand';
import { site } from '../data/site';
import { tips } from '../data/tips';
const sectionLinks = [{
  name: 'Special Offers',
  href: '#special-offers',
  icon: TagIcon,
  blurb: 'Seasonal offers are posted here when they are running. Call the estimate line for anything currently available.'
}, {
  name: 'Tips',
  href: '#tips',
  icon: LightbulbIcon,
  blurb: 'Practical planning and maintenance notes for Michigan homeowners, from kitchen prep to winter remodeling.'
}];
const archivePosts = [{
  title: 'Gutter Cleaning Special'
}];
export function Specials() {
  return <>
      <PageHero eyebrow="Specials & Tips" title="Offers and homeowner advice" description="This section holds our special offers and maintenance tips. Details for any current offer come from the estimate line." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Specials & Tips'
    }]} data-id="element-534" data-mp="eaengxgxgc73" />

      <div className="mx-auto max-w-5xl px-6 py-12 md:py-16" data-id="element-535" data-mp="27dp0yda1k4yr">
        <nav aria-label="Jump to section" className="grid gap-5 sm:grid-cols-2" data-id="element-536" data-mp="27c4aozurf86p">
          {sectionLinks.map(s => <a key={s.name} href={s.href} className="group rounded-sm border-2 border-steel-200 bg-white p-6 transition hover:border-safety hover:shadow-card" data-id="element-537" data-mp="2hbmpl1vtc3rw">
              <s.icon className="h-6 w-6 text-safety" aria-hidden="true" data-id="element-538" data-mp="2r1oge1fjw0ai" />
              <h2 className="mt-3 flex items-center gap-2 font-display text-2xl font-semibold uppercase tracking-tight text-ink" data-id="element-539" data-mp="2r3sge8abwf5i">
                {s.name}
                <ArrowDownIcon className="h-5 w-5 text-safety transition group-hover:translate-y-0.5" aria-hidden="true" data-id="element-540" data-mp="303fiyxesnr05" />
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-steel-500" data-id="element-541" data-mp="14zzlozzbnbgb">
                {s.blurb}
              </p>
            </a>)}
        </nav>

        <section id="special-offers" className="mt-12 scroll-mt-32" data-id="element-542" data-mp="1eorbp2ktnlol">
          <SectionHeading eyebrow="Archive" title="Special Offers" data-id="element-543" data-mp="1eq2fh2e9otfp" />
          <ul className="mt-5 divide-y divide-steel-200 overflow-hidden rounded-sm border border-steel-200 bg-white" data-id="element-544" data-mp="19wzsjd3zwi8h">
            {archivePosts.map(p => <li key={p.title} className="flex flex-wrap items-center justify-between gap-3 px-5 py-5" data-id="element-545" data-mp="1jnufyksz9nvi">
                <div data-id="element-546" data-mp="1xn3kgn7tmtjn">
                  <h3 className="font-display text-xl font-semibold uppercase tracking-tight text-ink" data-id="element-547" data-mp="1xlj0frj4ut01">
                    {p.title}
                  </h3>
                  <p className="mt-1 text-xs font-bold uppercase tracking-[0.16em] text-steel-400" data-id="element-548" data-mp="3anihym261kl">
                    Special Offers · Archived post
                  </p>
                </div>
                <a href={site.estimatePhone.href} className="inline-flex items-center gap-2 rounded-sm border-2 border-ink px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-ink transition hover:bg-ink hover:text-white" data-id="element-549" data-mp="29xl4ffte8jng">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-550" data-mp="256mle8h0t7gi" />
                  Ask about it
                </a>
              </li>)}
          </ul>
          <p className="mt-4 text-sm text-steel-500" data-id="element-551" data-mp="1r9g2mdwar8ra">
            Offer terms are not published here. To find out what is currently
            available, call{' '}
            <a href={site.estimatePhone.href} className="font-semibold text-safety hover:underline" data-id="element-552" data-mp="1hah4vqd2kxj2">
              {site.estimatePhone.display}
            </a>
            .
          </p>
        </section>

        <section id="tips" className="mt-14 scroll-mt-32" data-id="element-553" data-mp="3gmb8czu9y6hb">
          <SectionHeading eyebrow="Archive" title="Tips" description="Planning notes to help you get an accurate estimate and a practical design." data-id="element-554" data-mp="3glrqfj4mji3a" />
          <div className="mt-5 grid gap-5 md:grid-cols-2" data-id="element-555" data-mp="1cjrq1sw2r1gc">
            {tips.map(tip => <article key={tip.heading} className="flex flex-col rounded-sm border border-steel-200 bg-white p-6 shadow-card" data-id="element-556" data-mp="17i2f0d8uqns9">
                <div className="hatch mb-4 h-1.5 w-12" aria-hidden="true" data-id="element-557" data-mp="xlfvpsw6c4sc" />
                <h3 className="font-display text-xl font-bold uppercase leading-tight tracking-tight text-ink" data-id="element-558" data-mp="suhbii82emjt">
                  {tip.heading}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-steel-500" data-id="element-559" data-mp="ot46298vwldf">
                  {tip.body}
                </p>
              </article>)}
          </div>
          <p className="mt-5 text-sm text-steel-500" data-id="element-560" data-mp="etdcqaw28cex">
            Have a question about your own project? Call{' '}
            <a href={site.estimatePhone.href} className="font-semibold text-safety hover:underline" data-id="element-561" data-mp="9wdh6twu6s22">
              {site.estimatePhone.display}
            </a>
            .
          </p>
        </section>
      </div>

      <CTABand data-id="element-562" data-mp="9pb44xccy183" />
    </>;
}